const RELATIONSHIP_OPTIONS = [
  'Medical Power of Attorney (MPOA)',
  'Medical Health Care Proxy (HCP)',
  'Conservator',
  'Other',
];
export { RELATIONSHIP_OPTIONS };
